import axios from "axios";
import {
  ExchangeRate,
  ExchangeRateFilters,
  ExchangeRateListResponse,
} from "../interfaces/ExchangeRate";
import { apiUrl } from "../config/environment";
import { getAuthHeaders } from "../utils/authUtils";

const api: string = `${apiUrl}/api/fx`;

// GET /api/fx - List exchange rates with optional filters and pagination
export function listFx(
  params?: ExchangeRateFilters & {
    sortBy?: string;
    sortOrder?: "asc" | "desc";
    q?: string;
    minRate?: number;
    maxRate?: number;
  },
  options?: { signal?: AbortSignal },
): Promise<{ data: ExchangeRateListResponse }> {
  const searchParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.append(key, value.toString());
      }
    });
  }

  const url = searchParams.toString() ? `${api}?${searchParams.toString()}` : api;

  return axios.get(url, {
    ...getAuthHeaders(),
    signal: options?.signal,
  });
}

// PUT /api/fx/refresh - Force refresh exchange rates from external API (admin only)
export function refreshFx(): Promise<{ data: any }> {
  return axios.put(`${api}/refresh`, {}, getAuthHeaders());
}

// Type alias for the FX rate data structure
export type FxRate = ExchangeRate;
